<template>
    <div>
        <div class="alinhar-info justify-space-between mt-2 mb-2 acao-expandir-recolher">
            <h3 class="titulo">Listagem</h3>

            <div v-if="reajusteLotes.length > 1" class="text-xs-right">
                <v-btn v-if="ultimoEstadoTodosPaineis === 'recolhidos'" flat @click="expandirTodos"
                       class="botao-simples mr-3">
                    <v-icon left size="15">fas fa-chevron-down</v-icon>
                    Expandir Todos
                </v-btn>
                <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
                    <v-icon left size="15">fas fa-chevron-up</v-icon>
                    Recolher Todos
                </v-btn>
            </div>
        </div>

        <v-expansion-panel v-model="paineis" class="painel-itens" expand>

            <v-expansion-panel-content v-for="reajusteLote in reajusteLotes"
                                       :key="reajusteLote.id"
                                       class="painel-itens__linha borda-linha cabecalho-painel">
                <template v-slot:header>
                    <div class="alinhar-info">
                        <strong>{{ reajusteLote.rotulo }}</strong>
                        <span class="ml-4">
                            <strong>Arrematado por:&nbsp;</strong>
                            <span v-if="reajusteLote.valorArrematado !== null">
                                {{reajusteLote.valorArrematado | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                            </span>
                            <span v-else>&nbsp;-&nbsp;</span>
                        </span>

                        <AreaNegociacao v-if="reajusteLote.negociacao"
                                        :itemLote="reajusteLote"
                                        :aceita-valor-zero="aceitaValorZero"
                                        :casas-decimais="casasDecimais"
                                        :criterioJulgamento="criterioJulgamentoDaCompra"
                                        :simboloCriterioJulgamento="simboloCriterioJulgamentoDaCompra"
                                        :validarLancesPor="validarIntervaloLancesPor"
                                        :prefixSuffixValor="prefixOuSuffixValor"
                                        @atualizarValorNegociacao="atualizarValorNegociacao"
                                        @aceitarNegociacao="aceitarNegociacao"
                        />
                    </div>

                    <div class="painel-itens__info">
                        <p>Exclusivo {{formatarLista(portes) | azConcat}}:</p>
                        <p class="ml-2">{{ reajusteLote.porteExclusivo ? 'Sim' : 'Não' }}</p>
                    </div>
                </template>

                <painel-lote-tabela :itensReajuste="reajusteLote.reajusteItens"
                                    :situacaoReajusteLote="reajusteLote.situacao"
                                    :casasDecimais="casasDecimais"
                                    :casasDecimaisQuantidade="casasDecimaisQuantidade"
                                    :criterioJulgamento="criterioJulgamentoDaCompra"
                                    :simboloCriterioJulgamento="simboloCriterioJulgamentoDaCompra"
                                    :validarLancesPor="validarIntervaloLancesPor"
                                    :prefixSuffixValor="prefixOuSuffixValor"
                                    :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                    @salvarItem="salvarItemReajuste($event, reajusteLote)"
                                    @exibirDialogoConfirmacao="exibirDialogoConfirmacao(reajusteLote)"/>

                <hr style="color: #EFEFEF;" v-if="deveMostrarBotaoAnexarReadequacao(reajusteLote)">
                <div class="painel-itens__info mb-2 py-2" v-show="deveMostrarBotaoAnexarReadequacao(reajusteLote)">
                    <botao-enviar-readequacao v-if="deveMostrarBotaoAnexarReadequacao(reajusteLote)"
                                            @eventoAbrirModalReadequacao="eventoAbrirModalReadequacao(reajusteLote)"/>
                </div>
                <hr style="color: #EFEFEF;"  v-if="deveMostrarBotaoAnexarReadequacao(reajusteLote)">

                <div class="total alinhar-info mt-2 alinha-a-direita">
                    <p>
                        <strong>{{ isCriterioJulgamentoMaiorDesconto ? 'Desconto:' : 'Total Geral:' }}&nbsp;</strong>
                    </p>
                    <v-tooltip v-if="!isCriterioJulgamentoMaiorDesconto && verificarSeTotalMaiorQueNegociado(reajusteLote)" top >
                        <span class="red--text" slot="activator">
                            {{ reajusteLote.valorTotalGeral | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                        </span>
                        <span>
                            O total geral deve ser menor ou igual ao valor proposto que foi aceito.
                        </span>
                    </v-tooltip>
                    <p v-else>
                        {{ reajusteLote.valorTotalGeral | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                    </p>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
import PainelLoteTabela from './PainelLoteTabela'
import AreaNegociacao from '../negociacao/AreaNegociacao'
import {disputasCompraDireta, tiposCompraDireta} from '@/core/constants'
import BotaoEnviarReadequacao from '@/views/pages/fornecedor/resultado/documento-proposta/reajuste/painel-lote/BotaoEnviarReadequacao'

export default {
    name: 'PainelLote',
    props: {
        reajusteLotes: {
            type: Array,
            default: () => []
        },
        tipoCompraDireta: {
            type: String,
            default: null
        },
        disputaCompraDireta: {
            type: String,
            default: null
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        aceitaValorZero:{
            type: Boolean
        },
        criterioJulgamento:{
            type: String
        },
        simboloCriterioJulgamento:{
            type: String
        },
        validarLancesPor:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    components: {
        BotaoEnviarReadequacao,
        AreaNegociacao,
        PainelLoteTabela
    },
    mounted() {
        this.expandirTodos()
    },
    data() {
        return {
            paineis: [],
            ultimoEstadoTodosPaineis: 'recolhidos',
            totalmenteRecolhido: false,
            totalmenteExpandido: true,
        }
    },
    computed:{
        criterioJulgamentoDaCompra(){
            return this.criterioJulgamento
        },
        simboloCriterioJulgamentoDaCompra(){
            return this.simboloCriterioJulgamento
        },
        prefixOuSuffixValor(){
            return this.prefixSuffixValor
        },
        validarIntervaloLancesPor(){
            return this.validarLancesPor
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        }
    },
    methods: {
        atualizarValorNegociacao(dados) {
            const lote = dados.itemLote
            lote.negociacao.valor = dados.valor
        },
        salvarItemReajuste(item, lote) {
            this.atribuirItemReajustadoAoLote(item, lote)
            this.$emit('salvarItemReajuste', item)
        },
        atribuirItemReajustadoAoLote(item, lote) {
            lote.reajusteItens.find(itemReajuste => {
                if(itemReajuste.id === item.id) {
                    itemReajuste.valorUnitarioReajustado = item.valorUnitarioReajustado
                    return true
                }else{
                    return false
                }
            })
        },
        aceitarNegociacao(combo) {
            const lote = combo.itemLote
            const aceito = combo.aceito
            this.$emit('aceitarNegociacaoLote', {
                id: lote.negociacao.id,
                itemOuLoteReajusteId: lote.id,
                itemOuLoteCompraDiretaId: lote.loteCompraDiretaId,
                tipo: 'LOTE',
                aceito: aceito,
                valor: aceito? lote.negociacao.valor : null
            })
        },
        verificarSeTotalMaiorQueNegociado(lote) {
            if (lote.negociacao && lote.negociacao.aceito) {
                const tipoComDisputa = tiposCompraDireta.COM_DISPUTA.valor
                const disputaPorUnitario = disputasCompraDireta.UNITARIO.valor

                if (this.tipoCompraDireta === tipoComDisputa && this.disputaCompraDireta === disputaPorUnitario) {
                    return this.calcularTotalUnitarioLote(lote) > lote.negociacao.valor
                } else {
                    return lote.valorTotalGeral > lote.negociacao.valor
                }
            } else {
                return false
            }
        },
        calcularTotalUnitarioLote(lote) {
            let total = 0
            lote.reajusteItens.forEach(item => {
                total += item.valorUnitarioReajustado
            })
            return total
        },
        expandirTodos() {
            this.paineis = this.reajusteLotes.map(() => {
                return true
            })
            this.totalmenteExpandido = true
        },
        recolherTodos() {
            this.paineis = this.reajusteLotes.map(() => {
                return false
            })
            this.totalmenteExpandido = false
        },
        verificarEstadoPaineis(){
            this.totalmenteExpandido = !this.paineis.some(painel => painel === false)
            this.totalmenteRecolhido = !this.paineis.some(painel => painel === true)

            if (this.totalmenteExpandido) {
                this.ultimoEstadoTodosPaineis = 'expandidos'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoTodosPaineis = 'recolhidos'
            }
        },
        exibirDialogoConfirmacao(reajusteLote){
            this.$emit('exibirDialogoConfirmacao', reajusteLote)
        },
        eventoAbrirModalReadequacao(reajusteLote){
            this.$emit('eventoAbrirModalReadequacao', reajusteLote)
        },
        deveMostrarBotaoAnexarReadequacao(reajusteLote){
            return reajusteLote.documentoApresentadoId && !reajusteLote.uriReadequacao
        }
    },
    watch: {
        paineis() {
            this.verificarEstadoPaineis()
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-chip.v-chip--outline
        border none

    .v-chip .v-icon--left
        margin-right 6px

    .v-btn--icon
        width 26px

    .v-btn
        height 26px
        margin 0

    .v-chip--active, .v-chip--selected, .v-chip:focus:not(.v-chip--disabled)
        box-shadow none

    .v-chip--active:after, .v-chip--selected:after, .v-chip:focus:not(.v-chip--disabled):after
        background none

    .alinhar-info
        display flex
        align-items center

    .alinha-a-direita
        float right

    .titulo
        font-size 1.1rem
        color #777
        margin-left 16px
        clear both

    .painel-itens__info
        margin-right 20px

    @media (max-width 720px)
        .alinha-a-direita
            float left
            margin 0 10px 16px
            padding-top 10px

        .painel-itens__info
            margin-right 10px
</style>
